/** Line status in the Validate / History views (#13384): derived from the backend verification only. */
export enum enumHtsLineStatus {
  Validated = 'validated',
  /** The assistant gave no answer, or a validated code was removed: the line passes the filing gate without a code. */
  PassesWithoutCode = 'passesWithoutCode',
  NeedsClassification = 'needsClassification',
}
